<template>
   <SendPush />
</template>

<script>

// @ is an alias to /src
import SendPush from "@/components/SendPush.vue";

export default {
name: "SendPushs",
components: {
   SendPush,
},
};
</script>
